import { render, staticRenderFns } from "./ShippingRateForm.vue?vue&type=template&id=551a7890"
import script from "./ShippingRateForm.vue?vue&type=script&lang=js"
export * from "./ShippingRateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports